/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Content_Responsible_TitleInputs */

const en_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsible for Content`)
};

const de_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwortlich fuer den Inhalt`)
};

const fr_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsable du contenu`)
};

const es_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsable del contenido`)
};

const it_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile del contenuto`)
};

const nl_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verantwoordelijk voor de inhoud`)
};

const pl_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzialny za treść`)
};

const fi_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sisällöstä vastaava`)
};

const da_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarlig for indhold`)
};

const sv_impressum_content_responsible_title = /** @type {(inputs: Impressum_Content_Responsible_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansvarig för innehåll`)
};

/**
* | output |
* | --- |
* | "Responsible for Content" |
*
* @param {Impressum_Content_Responsible_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_content_responsible_title = /** @type {((inputs?: Impressum_Content_Responsible_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Content_Responsible_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_content_responsible_title(inputs)
	if (locale === "fr") return fr_impressum_content_responsible_title(inputs)
	if (locale === "es") return es_impressum_content_responsible_title(inputs)
	if (locale === "it") return it_impressum_content_responsible_title(inputs)
	if (locale === "nl") return nl_impressum_content_responsible_title(inputs)
	if (locale === "pl") return pl_impressum_content_responsible_title(inputs)
	if (locale === "fi") return fi_impressum_content_responsible_title(inputs)
	if (locale === "da") return da_impressum_content_responsible_title(inputs)
	if (locale === "sv") return sv_impressum_content_responsible_title(inputs)
	return en_impressum_content_responsible_title(inputs)
});